/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

export default [
  {
    path: '',
    // Relative to /src/views
    view: 'Dashboard',
  },
  {
    path: '/tunnels',
    name: 'Tunnels',
    view: 'Tunnels',
  },
  {
    path: '/terminals',
    name: 'Terminals',
    view: 'Terminals',
  },
  {
    path: '/terminals/:guid',
    name: 'Console',
    view: 'Console',
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    view: 'Unauthorized',
  },
]
